/**
 * Deep snake_case -> camelCase key conversion for API response bodies.
 *
 * Local replacement for the same-named helper from @aceup/components —
 * this repo no longer depends on that package. Recurses through plain
 * objects and arrays; anything else (strings, numbers, null, Dates, …)
 * passes through unchanged.
 */

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' &&
  value !== null &&
  !Array.isArray(value) &&
  value.constructor === Object;

const snakeToCamelKey = (key: string): string =>
  key.replace(/_([a-z0-9])/g, (_match, char: string) => char.toUpperCase());

export const keysToCamel = (input: unknown): unknown => {
  if (Array.isArray(input)) {
    return input.map((item) => keysToCamel(item));
  }
  if (isPlainObject(input)) {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [snakeToCamelKey(key), keysToCamel(value)])
    );
  }
  return input;
};

export default keysToCamel;
